import log from '@/logger'

function test() {
  // log.trace('Trace...')
  log.debug('Debug...')
  log.info('Info...')
  // log.warn('Warn...')
  // log.error('Error...')
  // log.warn('Log:Warn:StartingApp', new Date(), { name: 'Test:1' })
  // log.debug('Log:Debug:StartingApp', { name: 'Test:2-1' }, { name: 'Test:2-2' })
  // console.log('Console:Starting', { name: 'Test:3-1' }, { name: 'Test:3-2' })
}

export default {
  test
}